import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { href: '/', label: 'Startseite' },
  { href: '/leistungen', label: 'Leistungen' },
  { href: '/projekte', label: 'Projekte' },
  { href: '/ueber-uns', label: 'Über uns' },
  { href: '/jobs', label: 'Jobs' },
  { href: '/kontakt', label: 'Kontakt' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img
                src="https://static.readdy.ai/image/42a59d03aabdb3bbb4adf980fce8c22a/c496e7b7b0d35cec41af6fd81216106e.png"
                alt="IGM Facility Service Logo"
                className="h-12 w-auto object-contain"
              />
            </Link>

            <nav className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`text-sm font-medium transition-colors whitespace-nowrap ${
                    location.pathname === link.href
                      ? 'text-[#0D2B4E]'
                      : scrolled
                      ? 'text-gray-700 hover:text-[#0D2B4E]'
                      : 'text-white/90 hover:text-white'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            <a
              href="tel:+492102739807"
              className="hidden lg:flex items-center space-x-2 bg-[#0D2B4E] text-white px-6 py-3 rounded-lg hover:bg-[#0a2240] transition-colors whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-lg" />
              </div>
              <span className="font-semibold">02102 7398070</span>
            </a>

            <button
              className={`lg:hidden w-12 h-12 flex items-center justify-center cursor-pointer rounded-lg transition-colors ${
                scrolled ? 'hover:bg-gray-100' : 'hover:bg-white/10'
              }`}
              aria-label="Menü öffnen"
              onClick={() => setMobileOpen(true)}
            >
              <i className={`text-2xl ri-menu-line ${scrolled ? 'text-gray-900' : 'text-white'}`} />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 z-40 lg:hidden transition-opacity duration-300 ${
          mobileOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="absolute inset-0 bg-black/50" onClick={() => setMobileOpen(false)} />
        <div
          className={`absolute top-0 right-0 bottom-0 w-80 max-w-[85vw] bg-white shadow-xl transform transition-transform duration-300 ${
            mobileOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div className="flex flex-col h-full">
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <Link to="/">
                <img
                  src="https://static.readdy.ai/image/42a59d03aabdb3bbb4adf980fce8c22a/c496e7b7b0d35cec41af6fd81216106e.png"
                  alt="IGM Facility Service Logo"
                  className="h-10 w-auto object-contain"
                />
              </Link>
              <button
                className="w-12 h-12 flex items-center justify-center cursor-pointer rounded-lg hover:bg-gray-100 transition-colors"
                onClick={() => setMobileOpen(false)}
              >
                <i className="ri-close-line text-2xl text-gray-900" />
              </button>
            </div>

            <nav className="flex-1 overflow-y-auto p-4">
              <div className="space-y-1">
                {navLinks.map((link) => (
                  <Link
                    key={link.href}
                    to={link.href}
                    className={`flex items-center gap-3 px-4 py-4 rounded-lg text-base font-medium transition-all ${
                      location.pathname === link.href
                        ? 'bg-[#0D2B4E] text-white shadow-md'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </nav>

            <div className="p-4 border-t border-gray-200 bg-gray-50">
              <a
                href="tel:+492102739807"
                className="flex items-center justify-center gap-3 bg-[#0D2B4E] text-white px-6 py-4 rounded-lg hover:bg-[#0a2240] transition-colors w-full whitespace-nowrap shadow-lg cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-phone-fill text-xl" />
                </div>
                <span className="font-bold text-lg">02102 7398070</span>
              </a>
              <p className="text-center text-xs text-gray-500 mt-3">24/7 Notdienst verfügbar</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
